import React from 'react';

export default function Footer({ band }) {
    return (
        <footer className="text-white py-6">
            <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="text-sm text-white">© {new Date().getFullYear()} {band.name} — Tous droits réservés</div>
            </div>
        </footer>
    );
}